import type { BannerResponse } from "../generated/advertising/api";
import type {
  AuthorDetailedSerializer,
  ArtShortSerializer,
  CollectionWithRubricsSerializer,
  GenreFullSerializer,
  TagLightSerializer,
  DashboardArtSliderBlock,
  DashboardAuthorSliderBlock,
  DashboardBannerBlock,
  DashboardEditorialCollectionSliderBlock,
  DashboardGenreBlock,
  DashboardGenreSliderBlock,
  DashboardGenreListBlock,
  DashboardSpecialBlock,
  DashboardTagListBlock,
  GenreLightSerializer,
  RandomQuoteSerializer,
  DashboardSingleArtSliderBlock,
  CustomBlockArtSerializer,
  DashboardPromotionalBlock,
} from "../generated/foundation/api";

export enum DashboardBlockTypeEnum {
  artSlider = "art_slider",
  genreBlock = "genre_block",
  genreSlider = "genre_slider",
  editorialCollections = "editorial_collections",
  collectionsSlider = "collections_slider",
  quotesSlider = "quotes_slider",
  banners = "banners",
  connectToLibrary = "connect-to-library",
  ourPartners = "our-partners",
  authorsSlider = "authors_slider",
  exclusiveBanners = "exclusive_banners",
  tagsList = "tags_list",
  genresList = "genres_list",
  genresSliderSecondary = "genres_slider_secondary",
  nextArtInSeries = "next_art_in_series",
  artRating = "art_rating",
  singleArtSlider = "single_art_slider",
  promotional = "promotional",
}

export interface IRecommendationModelVersionType {
  response_model_name: string;
  response_model_tag: string;
}
export interface IDashboardBlock {
  authors?: AuthorDetailedSerializer[];
  arts?: CustomBlockArtSerializer[];
  collections?: CollectionWithRubricsSerializer[];
  genres?: GenreFullSerializer[];
  tags?: TagLightSerializer[];
  recommendationModelVersion?: IRecommendationModelVersionType;
  subgenres?: GenreLightSerializer[];
  banners?: BannerResponse[];
  art?: ArtShortSerializer;
  quotes?: RandomQuoteSerializer[];
}

export type TDashboardContent =
  | DashboardArtSliderBlock
  | DashboardAuthorSliderBlock
  | DashboardBannerBlock
  | DashboardEditorialCollectionSliderBlock
  | DashboardGenreBlock
  | DashboardGenreSliderBlock
  | DashboardGenreListBlock
  | DashboardSpecialBlock
  | DashboardTagListBlock
  | DashboardSingleArtSliderBlock
  | DashboardPromotionalBlock;

export interface IDashboardResponse {
  /**
   * Название вкладки
   */
  name: string;
  /**
   * Локализованный заголовок вкладки для отображения пользователю
   */
  title: string;
  /**
   * Тип дэшборда
   */
  type: string;
  /**
   * Контент вкладки
   */
  content: TDashboardContent[];
  /**
   * Описание заголовка
   */
  description: string;
}
